function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#5F37FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.8181 8.53912C14.8943 8.60127 14.9517 8.68524 14.9832 8.78084C15.0075 8.87641 15.0054 8.97724 14.9771 9.07161C14.9488 9.16597 14.8955 9.25 14.8234 9.31393L12.7613 11.4045L13.2606 14.3731C13.2784 14.4711 13.2691 14.5723 13.2337 14.665C13.1983 14.7576 13.1383 14.8376 13.0608 14.8957C12.9752 14.9607 12.872 14.9954 12.7662 14.995C12.6858 14.9953 12.6066 14.9737 12.5366 14.9323L9.99002 13.5369L7.44349 14.9323C7.35973 14.9819 7.26408 15.0051 7.16803 14.9991C7.07198 14.9931 6.97963 14.9582 6.90209 14.8985C6.82455 14.8389 6.76512 14.7571 6.73095 14.663C6.69678 14.5688 6.68933 14.4663 6.70949 14.3679L7.20881 11.3993L5.14662 9.3087C5.08243 9.24166 5.0369 9.15759 5.01491 9.06551C4.99292 8.97344 4.99529 8.87683 5.02179 8.78606C5.05073 8.69318 5.10396 8.61064 5.17545 8.54782C5.24694 8.485 5.33382 8.44442 5.42623 8.43067L8.26737 7.99165L9.54063 5.29483C9.58152 5.20646 9.64536 5.13194 9.72484 5.0798C9.80432 5.02766 9.89622 5 9.99002 5C10.0838 5 10.1757 5.02766 10.2552 5.0798C10.3347 5.13194 10.3985 5.20646 10.4394 5.29483L11.7127 7.99688L14.5538 8.43067C14.6501 8.43929 14.7419 8.47696 14.8181 8.53912Z",
  fill: "white"
});

var SvgAchievementsPageMobileNav = function SvgAchievementsPageMobileNav(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAchievementsPageMobileNav, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AchievementsPageMobileNav.f5fb7cb4.svg";
export { ForwardRef as ReactComponent };